import { render } from "./grouplist.vue?vue&type=template&id=189d2f68&scoped=true&ts=true"
import script from "./grouplist.vue?vue&type=script&lang=ts"
export * from "./grouplist.vue?vue&type=script&lang=ts"

import "./grouplist.vue?vue&type=style&index=0&id=189d2f68&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189d2f68"]])

export default __exports__